(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["_blog-post-content"] && !Shopify.designMode) return;
  try {
    const readingShells = document.querySelectorAll('.blog-post-reading-shell');

  readingShells.forEach((shell) => {
    const content = shell.querySelector('[data-article-content]');
    const desktopToc = shell.querySelector('[data-article-toc]');
    const mobileToc = shell.querySelector('[data-article-toc-mobile]');
    const normalizedHeading = (value) => value.normalize('NFD').replace(/\p{Diacritic}/gu, '').trim().toLowerCase();
    const faqHeading = [...content.querySelectorAll('h2')].find((heading) => {
      const label = normalizedHeading(heading.textContent);
      return label.includes('questions frequentes') || label === 'faq' || label.includes('frequently asked questions');
    });

    if (faqHeading) {
      const faqList = document.createElement('div');
      faqList.className = 'blog-post-faq';
      faqHeading.insertAdjacentElement('afterend', faqList);

      let node = faqList.nextElementSibling;
      let activeAnswer = null;

      while (node && node.tagName !== 'H2') {
        const nextNode = node.nextElementSibling;

        if (node.tagName === 'H3') {
          const item = document.createElement('details');
          const question = document.createElement('summary');
          const answer = document.createElement('div');
          item.className = 'blog-post-faq__item';
          question.className = 'blog-post-faq__question';
          answer.className = 'blog-post-faq__answer';
          question.textContent = node.textContent.trim();
          item.append(question, answer);
          faqList.append(item);
          activeAnswer = answer;
          node.remove();
        } else if (activeAnswer) {
          activeAnswer.append(node);
        } else {
          faqList.append(node);
        }

        node = nextNode;
      }
    }

    const headings = [...content.querySelectorAll('h2, h3')];

    if (headings.length < 2) {
      shell.querySelector('.blog-post-sidebar')?.remove();
      shell.querySelector('.blog-post-toc--mobile')?.remove();
    } else {
      const list = document.createElement('ol');

      headings.forEach((heading, index) => {
        if (!heading.id) heading.id = `article-section-${index + 1}`;
        const item = document.createElement('li');
        const link = document.createElement('a');
        item.dataset.level = heading.tagName.slice(1);
        link.href = `#${heading.id}`;
        link.textContent = heading.textContent.trim();
        item.append(link);
        list.append(item);
      });

      desktopToc.append(list);
      mobileToc.append(list.cloneNode(true));

      const links = [...desktopToc.querySelectorAll('a')];
      const observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (!entry.isIntersecting) return;
            links.forEach((link) => link.removeAttribute('aria-current'));
            desktopToc.querySelector(`a[href="#${entry.target.id}"]`)?.setAttribute('aria-current', 'true');
          });
        },
        { rootMargin: '-15% 0px -75% 0px' }
      );
      headings.forEach((heading) => observer.observe(heading));
    }

    const progressBar = document.querySelector('.blog-post-progress__bar');
    const updateProgress = () => {
      const rect = content.getBoundingClientRect();
      const distance = Math.max(content.offsetHeight - window.innerHeight, 1);
      const progress = Math.min(Math.max(-rect.top / distance, 0), 1);
      progressBar?.style.setProperty('transform', `scaleX(${progress})`);
    };
    updateProgress();
    document.addEventListener('scroll', updateProgress, { passive: true });

    const shareButton = shell.querySelector('[data-share-button]');
    shareButton?.addEventListener('click', async () => {
      const shareData = { title: shareButton.dataset.shareTitle, url: window.location.href };
      if (navigator.share) {
        await navigator.share(shareData).catch(() => {});
        return;
      }
      await navigator.clipboard.writeText(window.location.href);
      const originalText = shareButton.textContent;
      shareButton.textContent = shareButton.dataset.shareCopied;
      window.setTimeout(() => { shareButton.textContent = originalText; }, 1800);
    });
  });
  } catch(e) { console.error(e); }
})();

})();
